import { useEffect, useState } from "react"
import { EventEnroll } from "../../apis/event/event_enroll";
import { API_STATUS } from "../../constants";
import { SaveEventLike } from "../../apis/event/save_event_like";
import { RemoveEventLike } from "../../apis/event/remove_event_like";
import { SaveEventShare } from "../../apis/event/save_event_share";
import { SaveEventView } from "../../apis/event/save_event_view";
import PlaceHolder from "../../utils/placeholder";
import { Link } from "react-router-dom";
import { GetEventEnrolls } from "../../apis/event/get_event_enrolls";
import { useNavigate } from "react-router-dom";
import { FacebookIcon, WhatsappIcon, EmailIcon, TwitterIcon, TelegramIcon, InstapaperIcon, LinkedinIcon, XIcon, FacebookMessengerIcon, PinterestIcon } from "react-share";
import { FacebookShareButton, WhatsappShareButton, EmailShareButton, LinkedinShareButton, TwitterShareButton, TelegramShareButton, InstapaperShareButton, FacebookMessengerShareButton, PinterestShareButton } from "react-share";

export default function EventBoxFooter({ item, detail, showLike, showShare }) {
    const navigate = useNavigate();
    const [likeCount, setLikeCount] = useState(0);
    const [shareCount, setShareCount] = useState(0);
    const [viewCount, setViewCount] = useState(0);
    const [enroled, setEnroled] = useState(0);
    const [enrolApi, setEnrolApi] = useState(API_STATUS);
    const [userLike, setUserLike] = useState(false);
    const [loginId, setLoginId] = useState('');
    const [userType, setUserType] = useState('');
    const [viewApplied, setViewApplied] = useState(false);
    const [enrolStatus, setEnrolStatus] = useState(true);

    const [enrData, setEnrData] = useState([]);
    const [searchApi, setSearchApi] = useState(API_STATUS);
    const [noData, setNodata] = useState(false);
    const [loginSub, setLoginSub] = useState(false);
    const [subAlert, setSubAlert] = useState(false);
    const [loginData, setLoginData] = useState('');
    const [shareUrl, setShareUrl] = useState('https://website.filmwings.com/event_details/' + item.e_id);
    const [shareTitle, setShareTitle] = useState(item.e_title);
    const [shareBox, setShareBox] = useState(false);

    useEffect(() => {
        GetEventEnrolls(item.e_id, setSearchApi);
        if (new Date().getTime() > new Date(item.e_end).getTime()) {
            setEnrolStatus(false);
        }
    }, []);



    useEffect(() => {
        setEnrData([]);
        if (!searchApi.isLoader && !searchApi.isError && searchApi.data != null) {
            if (searchApi.data.status === 1) {
                setEnrData(searchApi.data.data);
            } else {
                setNodata(true);
            }
        }
    }, [searchApi]);

    useEffect(() => {
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);

        const utype = sessionStorage.getItem('USER_TYPE');
        setUserType(utype);

        if (item.userLike != "0") {
            setUserLike(true);
        }
        if (item.enrole == '0') {
            setEnroled(0);
        } else {
            setEnroled(1);
        }
        if (item.likeCount > 0) {
            setLikeCount(item.likeCount);
        }
        if (item.e_share_count > 0) {
            setShareCount(item.e_share_count);
        }
        if (item.e_view_count > 0) {
            setViewCount(item.e_view_count);
        }

        setLoginData(sessionStorage.getItem('LOGIN_DATA'));

        // const loginData = sessionStorage.getItem('LOGIN_DATA');
        // const logingUser = JSON.parse(loginData);
        // console.log(logingUser);

        // if (logingUser['subPayStatus'] !== null) {
        //     if (logingUser['subPayStatus'] === 1) {
        //         setLoginSub(true);
        //     }
        // }
    }, []);

    useEffect(() => {
        if (loginData !== "") {
            if (loginData !== null) {
                //  console.log(JSON.parse(loginData));
                const logingUser = JSON.parse(loginData);

                if (logingUser['subPayStatus'] !== null) {
                    if (logingUser['subPayStatus'] === 1) {

                        setLoginSub(true);
                    }
                }
            }
        }
    }, [loginData])

    const enrollNow = () => {
        if (sessionStorage.getItem("LIVENESS") === '0') {
            navigate("/video_kyc_pending");
        } else {
            if (loginSub) {
                const body = {
                    'comment': "",
                    'eventId': item.e_id
                };
                EventEnroll(body, setEnrolApi);
                setEnroled(1);
            } else {
                setSubAlert(true);
            }
        }
    }

    const _saveLike = () => {
        setUserLike(true);
        setLikeCount(likeCount + 1);

        const body = {
            "eventId": item.e_id,
            "ip": "",
            "device": ""
        };
        SaveEventLike(body, setEnrolApi);
    }

    const _removeLike = () => {
        setUserLike(false);
        setLikeCount(likeCount - 1);
        RemoveEventLike(item.e_id, setEnrolApi);
    }

    const _saveShare = () => {
        setShareCount(shareCount + 1);
        SaveEventShare(item.e_id, setEnrolApi);
    }

    return <div>
        <div className="sm:p-4 p-2.5 flex items-center gap-4 text-xs font-semibold">
            <div className="flex items-center gap-2.5">
                {
                    userLike &&
                    <button
                        onClick={_removeLike}
                        type="button" className="button__ico text-red-500 bg-red-100 dark:bg-slate-700">
                        <ion-icon className="text-lg" name="heart"><i className="fa fa-heart"></i></ion-icon>
                    </button>
                }
                {
                    !userLike &&
                    <button
                        onClick={_saveLike}
                        type="button" className="button__ico bg-slate-200/70 dark:bg-slate-700">
                        <ion-icon className="text-lg" name="heart"><i className="fa fa-heart"></i></ion-icon>
                    </button>
                }
                {
                    likeCount > 0 && showLike === 1 && <span>{likeCount}</span>
                }
            </div>
            <div className="flex items-center gap-3">
                <button type="button" className="button__ico bg-slate-200/70 dark:bg-slate-700">
                    <ion-icon className="text-lg" name="chatbubble-ellipses">
                        <i className="fa fa-eye"></i>
                    </ion-icon> </button>
                {
                    viewCount > 0 && <span>{viewCount}</span>
                }
            </div>

            <div className="flex items-center gap-3">
                <button
                    onClick={() => setShareBox(!shareBox)}
                    type="button" className="button__ico">
                    <ion-icon className="text-xl" name="share-outline">
                        <i className="fa fa-share"></i>
                    </ion-icon> </button>
                {
                    shareCount > 0 && showShare === 1 && <span>{shareCount}</span>
                }
            </div>

            {
                subAlert &&
                <div className="ml-auto text-blue-400 dark:text-white" style={{ fontSize: 15 }}>
                    <a href={'/profile/' + loginId}>Subscribe as artist to apply to the event.</a>
                </div>
            }
            {
                !subAlert &&

                <div className="ml-auto">
                    {
                        enroled === 0 && loginId !== item.u_token && userType === '0' && enrolStatus &&
                        <button
                            onClick={enrollNow}
                            type="button" className="bg-secondery  font-semibold px-4 py-1.5 rounded-lg text-sm border1"> Apply </button>
                    }
                    {
                        enroled === 1 &&
                        <span className="text-blue-400" style={{ fontSize: 14 }}>Applied</span>
                    }
                    {
                        !detail &&
                        <a href={'/event_details/' + item.e_id}
                            onClick={() => {
                                SaveEventView(item.e_id);
                            }}
                            className="bg-secondery  font-semibold px-4 py-1.5 rounded-lg text-sm border1 ml-1"> VIEW </a>
                    }

                    {
                        detail && loginId === item.u_token &&
                        <Link
                            onClick={() => {
                                // GetEventEnrolls(item.e_id, setSearchApi);
                                setViewApplied(!viewApplied);
                            }}
                            className="bg-secondery  font-semibold px-4 py-1.5 rounded-lg text-sm border1 ml-1"> List of Applied {enrData.length > 0 ? '(' + enrData.length + ')' : ''} </Link>
                    }
                </div>
            }



        </div>
        {
            shareBox &&

            <div style={{ paddingLeft: 10 }}>
                <p>Share on</p>
                <div>
                    <FacebookShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <FacebookIcon round={true} size={30} />
                    </FacebookShareButton>

                    <FacebookMessengerShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <FacebookMessengerIcon round={true} size={30} />
                    </FacebookMessengerShareButton>

                    <WhatsappShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <WhatsappIcon round={true} size={30} />
                    </WhatsappShareButton>

                    <EmailShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <EmailIcon round={true} size={30} />
                    </EmailShareButton>

                    <LinkedinShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <LinkedinIcon round={true} size={30} />
                    </LinkedinShareButton>

                    <TwitterShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <XIcon round={true} size={30} />
                    </TwitterShareButton>

                    <TelegramShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <TelegramIcon round={true} size={30} />
                    </TelegramShareButton>

                    <InstapaperShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <InstapaperIcon round={true} size={30} />
                    </InstapaperShareButton>

                    <PinterestShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <PinterestIcon round={true} size={30} />
                    </PinterestShareButton>
                </div>
            </div>
        }
        {
            viewApplied &&

            <div className="p-3">
                {
                    searchApi.isLoader &&
                    <svg aria-hidden="true" className="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                }

                {
                    noData &&
                    <div className="p-3">Nobody applied yet</div>
                }

                {
                    enrData.length > 0 &&
                    <div className="p-2 space-y-2 dark:text-white">

                        <div className="flex items-center justify-between py-2.5 px-3 font-semibold">
                            <h4>List of applied</h4>
                        </div>
                        {
                            enrData.map((item, i) =>
                                <a key={i} href={'/profile/' + item.u_token} className="relative flex items-center gap-3 p-2 duration-200 rounded-xl hover:bg-secondery">
                                    <img src={item.user_pic} alt="" className="bg-gray-200 rounded-full w-10 h-10" />
                                    <div className="fldex-1 min-w-0">
                                        <h4 className="font-medium text-sm text-black dark:text-white">  {item.first_name + ' ' + item.last_name} </h4>
                                        <div className="text-xs text-gray-500 font-normal mt-0.5 dark:text-white-80"> {item.city} </div>
                                    </div>
                                </a>
                            )
                        }




                    </div>
                }
            </div>
        }
    </div>
}